module.exports = __webpack_public_path__ + "img/hubin01.693119f2.jpg";